import * as React from 'react';
import Button from "@material-ui/core/Button";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import AuthService from '../../services/AuthService'
import Storage from "src/common/Storage";
import { useDispatch } from "react-redux";
import { logout } from "src/redux/actions";


const ButtonAADLogin = ({ tenantConfig, loginType, btnText, loginRequest, setLoading, domain, show = true, onAuth }) => {

    const isAuthenticated = useIsAuthenticated();
    const dispatch = useDispatch();
    const { accounts, instance, inProgress } = useMsal();

    const handleLoginAAD = async () => {

        if (inProgress !== 'none') {
            return;
        }

        try {
            sessionStorage.clear()
            Storage.setLoginType(loginType);
            Storage.setTenant(JSON.stringify(tenantConfig));
            Storage.setDomain(domain);

            await instance.loginRedirect(loginRequest).catch((error) => {
                console.log(error)
            })
        } catch (error) {
            console.log(error)
        }
    }

    const handleAuthLogin = () => {
        try {

            if (accounts[0].localAccountId) {

                Storage.setLoginType(loginType);
                Storage.setTenant(JSON.stringify(tenantConfig));
                Storage.setDomain(domain);

                instance.acquireTokenSilent({
                    scopes: loginRequest.scopes,
                    account: accounts[0]
                }).then((response) => {

                    if (response) {
                        setLoading(true)
                        AuthService.loginAD(response.accessToken, 'AD').then((responseAD) => {
                            setLoading(false)
                            if (typeof onAuth === 'function') {
                                onAuth("AD", response.accessToken, responseAD)
                            }
                        }).catch(e => {
                            Storage.clear();
                            dispatch(logout());
                            setLoading(false)
                        })
                    }
                }).catch(error => {
                    if (error.name === "InteractionRequiredAuthError" || error.errorCode === "authority_mismatch") {
                        instance.logout(); 
                    } else {
                        console.error(error);
                    }
                });
            }

        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    React.useEffect(() => {
        if (isAuthenticated && inProgress === 'none' && accounts.length > 0) {
            handleAuthLogin()
        }
        // eslint-disable-next-line
    }, [isAuthenticated, inProgress, accounts])

    return show ? <Button color='primary' id="login_ad_btn" data-testid={`btn-login-${tenantConfig.clientId}`} variant="contained" fullWidth onClick={() => handleLoginAAD()}>{btnText}</Button> : <></>
}

export default ButtonAADLogin;